
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetActivatedNohdgcogIec as ObiAisTargetActivatedNohdgcogIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-activated-nohdgcog-iec.js';
 
 
 

 
 export const ObiAisTargetActivatedNohdgcogIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-activated-nohdgcog-iec',
   elementClass: ObiAisTargetActivatedNohdgcogIecElement,
   events: {
     
   }
  });
 
 